// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorOption_HzwyC {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid transparent;
}

.optionRing_slUqh {
    /* width: calc(100% - 4px);
    height: calc(100% - 4px); */
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid var(--color-base100);
}

.innerOption_NAziw {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/editor/ColorOption.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI;+BAC2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".colorOption {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border: 1px solid transparent;\n}\n\n.optionRing {\n    /* width: calc(100% - 4px);\n    height: calc(100% - 4px); */\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 2px solid var(--color-base100);\n}\n\n.innerOption {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorOption": `colorOption_HzwyC`,
	"optionRing": `optionRing_slUqh`,
	"innerOption": `innerOption_NAziw`
};
export default ___CSS_LOADER_EXPORT___;
